import { z } from 'zod';

export const Role = z.enum(['USER', 'ADMIN']);
export type Role = z.infer<typeof Role>;

export const RegisterInput = z.object({
  email: z.string().email(),
  password: z.string().min(8).max(200),
  firstName: z.string().trim().min(1).max(80),
  lastName: z.string().trim().min(1).max(80),
  /** Muss true sein — ohne Zustimmung zu AGB & Datenschutz gibt es kein Konto. */
  acceptTerms: z.literal(true),
});
export type RegisterInput = z.infer<typeof RegisterInput>;

export const LoginInput = z.object({
  email: z.string().email(),
  password: z.string().min(1).max(200),
});
export type LoginInput = z.infer<typeof LoginInput>;

export const ForgotPasswordInput = z.object({
  email: z.string().email(),
});
export type ForgotPasswordInput = z.infer<typeof ForgotPasswordInput>;

export const ResetPasswordInput = z.object({
  token: z.string().min(20).max(500),
  password: z.string().min(8).max(200),
});
export type ResetPasswordInput = z.infer<typeof ResetPasswordInput>;

export const UserDTO = z.object({
  id: z.string(),
  email: z.string().email(),
  name: z.string().nullable(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  role: Role,
  active: z.boolean(),
  /** null = Schnellstart noch nicht gesehen. */
  onboardedAt: z.string().nullable(),
  /** Letzter authentifizierter API-Request. null = noch nie (bzw. vor Einführung des Trackings). */
  lastSeenAt: z.string().nullable(),
  createdAt: z.string(),
});
export type UserDTO = z.infer<typeof UserDTO>;

export const MeResponse = z.object({
  user: UserDTO.nullable(),
});
export type MeResponse = z.infer<typeof MeResponse>;

export const AuthResponse = z.object({
  user: UserDTO,
});
export type AuthResponse = z.infer<typeof AuthResponse>;
